/**
 * The backend answers a failed write in one of two body shapes, and both are written for the farmer:
 *
 *  - bean validation (400) sends `{ field: message }`, so the values are the reasons
 *  - `NotFoundException` (404), `ValidationException` (400) and `DomainConflictException` (409) send
 *    the message as a bare string
 *
 * Only a genuine internal fault reaches the caller as the opaque "Internal server error", which is
 * the one case worth replacing with a message that has context. Guessing a reason from the status
 * instead — the shape this replaced — printed "already exists" at every blank required field.
 */
const OPAQUE_SERVER_ERROR = 'Internal server error';

export const apiErrorMessage = (err, fallback) => {
  const data = err?.response?.data;

  if (typeof data === 'string') {
    const message = data.trim();
    if (message && message !== OPAQUE_SERVER_ERROR) {
      return message;
    }
  }

  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const messages = Object.values(data).filter(
      (value) => typeof value === 'string' && value.trim());
    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  return fallback;
};

/** `fallback: reason` — for callers that want the operation named alongside the server's reason. */
export const apiErrorMessageWithContext = (err, fallback) => {
  const message = apiErrorMessage(err, null);
  return message ? `${fallback}: ${message}` : fallback;
};
